import { render, staticRenderFns } from "./taskRelationship.vue?vue&type=template&id=3858e44c&"
import script from "./taskRelationship.vue?vue&type=script&lang=js&"
export * from "./taskRelationship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports